import script from "./ContentUs.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentUs.vue?vue&type=script&setup=true&lang=js"

import "./ContentUs.vue?vue&type=style&index=0&id=2ef3e135&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ef3e135"]])

export default __exports__